module.exports = "<div class=\"title-page\" [ngClass]=\"{ 'title-page--centered': centered }\">\n  <h2 class=\"title-page__title headingSmall\">{{title}}</h2>\n  <span class=\"title-page__description\" [innerHtml]=\"description\"></span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/shared/components/title-page/title-page.component.html
// module id = ../../../../../src/app/shared/components/title-page/title-page.component.html
// module chunks = main